<div class="user-card"
     [ngClass]="{selected: isSelected | async, inactive: !isActive}"
     *ngIf="user !== null"
     (click)="onClick()">
    <div class="user-status"
         *ngIf="user.isExploit">
        <div class="highlighting"
             [ngClass]="user.exploitClass"
             [innerHTML]="user.exploitKey | translate"></div>
    </div>
    <div class="user-status"
         *ngIf="!isActive">
        <div class="highlighting inactive">{{ 'STATUSES.INACTIVE' | translate }}</div>
    </div>
    <div class="identicon">
        <aa-avatar-icon [src]="user.identiconDataUrl"
                        [alt]="user.firstLastName"
                        [size]="'48px'">
        </aa-avatar-icon>
    </div>
    <div class="user-actions">
        <div #actions class="action-menu" (click)="actionClick($event)">
            <i class="fas fa-ellipsis-v"></i>
        </div>
    </div>
    <div class="user-impe">
        <aa-btn-action-secondary *ngIf="withImpersonate"
                                 [size]="'small'"
                                 [btnText]="'BUTTON.IMPERSONATE.ENTER' | translate"
                                 (click)="onImpersonate($event)">
        </aa-btn-action-secondary>
    </div>
    <div class="user-details"
         [ngClass]="withRoles ? 'with-roles' : ''">
        <div class="user-name aa-color-primary-normal aa-medium-current-text">{{ user.firstLastName }}</div>
        <div class="user-title aa-light-current-text aa-color-primary-normal">
            {{ user.title !== null ? user.title : ' ' }}
        </div>
        <div class="user-roles"
             *ngIf="withRoles">
            <aa-icon-appli [appRoles]="appRoles"
                           [external]="user.external">
            </aa-icon-appli>
        </div>
        <div class="user-email overflow-ellipsis aa-color-grey-light aa-medium-current-text"
             title="{{ user.email }}">
            <a [href]="mailto">{{ user.email }}</a>
        </div>
        <div class="user-phone overflow-ellipsis aa-color-grey-light aa-medium-current-text"
             title="{{ user.phoneNumber }}">
            <a [href]="telto">{{ user.phoneNumber }}</a>
        </div>
    </div>
</div>
